import React from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Language, Translate } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    handleClose();
  };

  const getCurrentLanguage = () => {
    return i18n.language === "ar" ? "العربية" : "English";
  };

  const getCurrentLanguageCode = () => {
    return i18n.language;
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          ml: 1,
          color: "inherit",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
        aria-label="language switcher"
      >
        <Language />
        <Typography variant="caption" sx={{ ml: 0.5, fontSize: "0.75rem" }}>
          {getCurrentLanguageCode().toUpperCase()}
        </Typography>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            minWidth: 150,
            mt: 1,
          },
        }}
      >
        <MenuItem
          onClick={() => handleLanguageChange("ar")}
          selected={i18n.language === "ar"}
        >
          <ListItemIcon>
            <Translate fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="العربية"
            secondary={i18n.language === "ar" ? t("common.language") : ""}
          />
        </MenuItem>

        <MenuItem
          onClick={() => handleLanguageChange("en")}
          selected={i18n.language === "en"}
        >
          <ListItemIcon>
            <Translate fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="English"
            secondary={i18n.language === "en" ? t("common.language") : ""}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
